import ColorUtils from '../services/color.service'

const DATAVIZ_LIGHT_START = '#030061'; // veneer-essentials-tokens.scss $color-blue-9
const DATAVIZ_LIGHT_END = '#BD7801'; // $color-yellow6

const DATAVIZ_DARK_START = '#5E57E8'; // veneer-essentials-tokens.scss $color-blue-3
const DATAVIZ_DARK_END = '#FAC461'; // $color-yellow2

const DATAVIZ_LIGHT_KEY = 'dv_light';
const DATAVIZ_DARK_KEY = 'dv_dark';

export default {
  init: function(sheet) {
    function populateDataVizColors(ss, scheme, className) {
      // console.log(className+':', scheme);
      // let ss = document.styleSheets[0];
      let rule = ':root.'+className +'{\n';
      const element = document.querySelector(':root.' + className);
      for (let i = 0; i < scheme.length; i++) {
        for (let j = 0; j < scheme[i].length; j++) {
          rule += '--dataViz-category-value' + (i + 1) + '-default-' + j + ': ' + scheme[i][j] +';\n';
        }
      }
      for (let i = 0; i < scheme.length; i++) {
        for (let j = 0; j < scheme[i].length; j++) {
          rule += '--dataViz-gradient-category' + (i + 1) + '-default-' + j + ': linear-gradient(180deg, ' + scheme[i][j] +'1A 0%, ' + scheme[i][j] +'00 100%);\n';
        }
      }
      rule += '}\n';
      ss.insertRule(rule, 0);
      // console.log(rule);
    }

    function removeCSSRule(sheet, className) {
      let selector = ':root.'+className;
      try {
        // Loop backward through rules so indices don't shift when deleted
        for (let j = sheet.cssRules.length - 1; j >= 0; j--) {
          if (sheet.cssRules[j].selectorText === selector) {
            sheet.deleteRule(j);
          }
        }
      } catch (e) {
        // Catch SecurityErrors caused by cross-origin/external domain stylesheets
        console.warn("Could not read stylesheet rules due to CORS restrictions:", e);
      }
    }


    function getDataVizColors(startColor, endColor, key) {
      let colors = [startColor, endColor]; // --dataViz-category-value2-default-0, --dataViz-category-value2-default-1
      let storageValue = window.localStorage.getItem(key);
      if (storageValue) {
        let storageColors = storageValue.split(',');
        if (storageColors && storageColors.length > 1) {
          if (CSS.supports('color', storageColors[0])) {
            colors[0] = storageColors[0];
          }
          if (CSS.supports('color', storageColors[1])) {
            colors[1] = storageColors[1];
          }
        }
      }
      return colors;
    }

    populateDataVizColors(sheet, ColorUtils.create(...(getDataVizColors(DATAVIZ_LIGHT_START, DATAVIZ_LIGHT_END, DATAVIZ_LIGHT_KEY))), 'light');
    populateDataVizColors(sheet, ColorUtils.create(...(getDataVizColors(DATAVIZ_DARK_START, DATAVIZ_DARK_END, DATAVIZ_DARK_KEY))), 'dark');

    // todo this only works if a different frame changes the storage - this is here as an example of how to replace colors on a change
    window.addEventListener('storage', (event) => {
      // console.log('Received storage event:', event);
      if (event.key === DATAVIZ_DARK_KEY ) {
        let colors = [DATAVIZ_DARK_START, DATAVIZ_DARK_END];
        if (event.newValue) {
          let item = window.localStorage.getItem(DATAVIZ_DARK_KEY);
          if (item) {
            let newColors = item.split(',');
            if (colors && colors.length > 1) {
              colors = newColors;
            }
          }
        }
        if (colors && colors.length > 1) {
          removeCSSRule(sheet, 'dark')
          populateDataVizColors(sheet, ColorUtils.create(colors[0], colors[1]), 'dark');
        }
      } else if (event.key === DATAVIZ_LIGHT_KEY ) {
        let colors = [DATAVIZ_LIGHT_START, DATAVIZ_LIGHT_END];
        if (event.newValue) {
          let item = window.localStorage.getItem(DATAVIZ_LIGHT_KEY);
          if (item) {
            let newColors = item.split(',');
            if (colors && colors.length > 1) {
              colors = newColors;
            }
          }
        }
        if (colors && colors.length > 1) {
          removeCSSRule(sheet, 'light')
          populateDataVizColors(sheet, ColorUtils.create(colors[0], colors[1]), 'light');
        }
      }
    });
    
  }
};
